import { useMemo } from 'react';

export function Heatmap({ activity, weeks = 14 }: { activity: string[]; weeks?: number }) {
  const dates = useMemo(() => {
    const result: { date: string; active: boolean; today: boolean }[] = [];
    const active = new Set(activity);
    const now = new Date();
    for (let i = weeks * 7 - 1; i >= 0; i--) {
      const date = new Date(now);
      date.setDate(now.getDate() - i);
      const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString().slice(0, 10);
      result.push({ date: local, active: active.has(local), today: i === 0 });
    }
    return result;
  }, [activity, weeks]);

  return <div className="heatmap" style={{ '--weeks': weeks } as React.CSSProperties}>{dates.map((item) => <span key={item.date} className={`${item.active ? 'active' : ''} ${item.today ? 'today' : ''}`} title={`${item.date}${item.active ? ' · practiced' : ''}`} />)}</div>;
}

